import React, {Component} from 'react';
import {BigButtonTool} from "../../oneLineToolSpace";
import menuVideoIcon from "../../../components/image/menuvideo.png";
import {uuid,permissionCheck} from "../../../../../utils";
import VideoUpload from "../../../components/videoUpload/VideoUpload";
import MedialSelect from "../components/medialSelect";
import localUpload from "../components/img/localUpload.png";
import resourceSelect from "../components/img/resourceSelect.png";
import address from "../components/img/address.png";
import VideoAmend from "../../../components/toolbarAmendModal/videoAmend";
import CurrencyResourceDialog from "../../../../resource/view/dialog/CurrencyResourceDialog";
import InterviewTaskVideo from "../../../components/pluginsSpace/taskVideo/taskVideo";
import taskVideo from "../../../../editor/components/image/taskVideo.png";
import BaseComponent from "../../../../../base/BaseComponent";
import {message} from "antd";
import {VIDEO_TYPE_ORIGINAL} from "../../../../../constants";
const sysConfigGetValueByKey = (key, defaultValue = '') =>{
    return window.sysConfig && window.sysConfig.getValueByKey(key, defaultValue) || defaultValue
};

export const buildInsertVideoHtml = ({url, playUrl, videoPic, autoplay=false, width, duration, newHeight="auto",name,float})=>{
    if(!width){
        width = sysConfigGetValueByKey("editor.content.video.insert.width", "500");
    }
    if(float === "center"){
        return `<p style="text-align: center"><img
        autoplay="${autoplay}"
        draggable="false" src="${playUrl}" 
        duration="${duration}" 
        width="${width}" 
        video-pic="${videoPic}" 
        video-src="${url}" 
        source-url="${url}" 
        alias-label="video" 
        name="${name}"
        height="${newHeight}" 
        autoPlay="${autoplay}"/></p>`
    }

    return `<p><img style="${float?"float:"+float:""}"
        autoplay="${autoplay}"
        draggable="false" src="${playUrl}" 
        duration="${duration}" 
        width="${width}" 
        video-pic="${videoPic}" 
        video-src="${url}" 
        source-url="${url}" 
        alias-label="video" 
        name="${name}"
        height="${newHeight}"
        autoPlay="${autoplay}"/></p>`
};

class VideoTool extends BaseComponent {

    state = {
        dialog: false,
        dialogKey: uuid(),
        isHover: "none",
        modalKey: uuid(),
        closeKey: uuid()
    };

    videoUploadOk = (fileList) => {
        let videoHTML = '';
        fileList && fileList.map(file => {
            videoHTML += buildInsertVideoHtml({
                    ...file,
                    originalWith:file.width, originalHeight:file.height,
                    width: file.cssWidth?parseInt(file.cssWidth):null,
                    height: file.cssHeight?parseInt(file.cssHeight):null,
                    autoplay: file.cssAutoPlay,
                });
        });
        let isSuccess = true;
        if(videoHTML){
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", videoHTML);
        }
        if(isSuccess) {
            this.videoUploadHandleCancel();
        }
    };

    insertVideoToContent(fileList,call){
        let videoHTML = '';
        fileList && fileList.map(file => {
            videoHTML += buildInsertVideoHtml({
                ...file,
                url:file.mp4Path?file.mp4Path:file.path,
                videoPic:file.url?file.url:file.icon,
                originalWith:file.width,
                originalHeight:file.height,
                width: file.cssWidth?parseInt(file.cssWidth):0
            });
        });
        let isSuccess = true;
        if(videoHTML){
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", videoHTML);
        }
        call&&call(isSuccess)
    }

    videoUploadHandleCancel = () => {
        this.setState({
            dialog: false,
            dialogKey: uuid(),
        });
    };

    render() {
        return (
            <>
                <div style={{position:'relative'}}
                     onMouseEnter={() => {this.setState({isHover: "block"})}}
                     onMouseLeave={() => {this.setState({isHover: "none"})}}
                     onClick={()=>{this.setState({isHover: "none"})}}
                >
                    <BigButtonTool src={menuVideoIcon} text={"视频"} height={this.props.height} width={this.props.width}
                                   onClick={()=>{this.setState({dialog:true})}}
                    />

                    {/*视频下拉框*/}
                    <div style={{
                        position: 'absolute',
                        top: '58px',
                        left: "50px",
                        zIndex: 999,
                        display: this.state.isHover
                    }}>
                        <MedialSelect>
                            <div className={'selectList'} onClick={()=> this.setState({dialog:true})}
                                 style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}>
                                <img src={localUpload} style={{marginRight: "8px"}}/>
                                <span>本地上传</span>
                            </div>
                            {permissionCheck('right_to_use_zyk')? <div className={'selectList'}
                                                                       onClick={()=>this.resourceDialog.show()}
                                                                       style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}>
                                <img src={resourceSelect} style={{marginRight: "8px"}}/>
                                <span>资源库选择</span>
                            </div>:null}

                            <div className={'selectList'}
                                 style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}
                                 onClick={()=>{
                                     this.VideoAmend.showModal()
                                 }}>
                                <img src={address} style={{marginRight: "8px"}}/>
                                <span>地址插入</span>
                            </div>
                            {
                                this.urlParams?.taskId?(
                                    <div className={'selectList'}
                                         style={{width: '119px', height: '32px', padding: '0 10px', lineHeight: "32px"}}
                                         onClick={()=>{
                                             this.InterviewTaskVideo.showModal()
                                         }}>
                                        <img src={taskVideo} style={{marginRight: "8px"}}/>
                                        <span>任务视频</span>
                                    </div>
                                ):""
                            }
                        </MedialSelect>
                    </div>
                </div>
                <CurrencyResourceDialog
                    onOk={(checkedData)=>{
                        checkedData && checkedData.map(item=>{
                            item.playUrl = item.thumbnailsPlayPath?item.thumbnailsPlayPath:item.icon;
                            item.url = item.thumbnailsPath?item.thumbnailsPath:item.path;
                        });
                        this.insertVideoToContent(checkedData);
                    }}
                    onCallBackOk={(checkedData,call)=>{
                        this.checkFileType(checkedData,(newFiles)=>{
                            newFiles && newFiles.map(item=>{
                                item.playUrl = item.thumbnailsPlayPath?item.thumbnailsPlayPath:item.icon;
                                item.url = item.thumbnailsPath?item.thumbnailsPath:item.path;
                            });
                            this.insertVideoToContent(newFiles,call);
                        },call);
                    }}
                    indexName={"video"}
                    ref={resourceDialog=>this.resourceDialog = resourceDialog}
                    key={this.state.closeKey}
                    onCloseCall={()=>{this.setState({closeKey:uuid()})}}/>
                <VideoUpload key={this.state.dialogKey} videoUpload={this.state.dialog} handleOk={(fileList)=>this.videoUploadOk(fileList)}
                             handleCancel={() => this.videoUploadHandleCancel()}/>
                <VideoAmend key={this.state.modalKey} ref={(e)=>this.VideoAmend=e} title={"插入视频"} editor={this.props.editor} onCloseCall={()=>{this.setState({modalKey:uuid()})}}/>
                <InterviewTaskVideo key={this.state.taskKey} ref={(e)=>this.InterviewTaskVideo=e} title={"任务视频"} editor={this.props.editor}
                                      onCloseCall={()=>{this.setState({taskKey:uuid()})}}
                />
            </>

        );
    }
    newVidType=VIDEO_TYPE_ORIGINAL;
    newVidTypes = [...this.newVidType,...this.newVidType.toUpperCase()];
    checkFileType = (files,checkCall,closeCall) => {
        if(!files?.length) {
            // message.destroy();
            // message.warning("请先选择一个资源");
            closeCall&&closeCall(true);
            return false
        }
        let newFiles = files;
        let checkTypeResult = files.every(file=>this.newVidTypes.indexOf(file.suffix)>-1);
        if(!checkTypeResult) {
            message.destroy();
            message.error(`目前只支持以下格式：${this.newVidType.join("，")}`);
            return false
        }
        let maxSize = this.sysConfigGetValueByKey("Upload.max.videoSize", "500") * 1;
        let checkSizeResult = files.every(file=>(file.size / 1024 / 1024) <= maxSize);
        if(!checkSizeResult) {
            message.destroy();
            message.error(`单个文件大小不能超过${maxSize}MB！`);
            return false
        }
        checkCall&&checkCall(newFiles)
    }
}

export default VideoTool;